import {AppState} from '../../..';

export const transportCardPaymentHistorySelector = (state: AppState) => state.transportCard.cardPaymentHistory.data;

export const transportCardPaymentHistoryIsLoadedSelector = (state: AppState) =>
  state.transportCard.cardPaymentHistory.isLoaded;
